import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetIncomeDetailsQuery } from '../slices/incomesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import IncomeCarousel from '../components/IncomeCarousel';

const IncomeScreen = () => {
  const { id: incomeId } = useParams();
  const { data: income, isLoading, error } = useGetIncomeDetailsQuery(incomeId);

  const renderIncomeDetails = () => (
    <>
      <Meta title={income.date} description={income.account} />
      <Row>
        <Col md={6}>
          {/* Display income images using IncomeCarousel */}
          {income.images && income.images.length > 0 ? (
            <IncomeCarousel images={income.images} />
          ) : (
            <Message variant="info">No images available for this income</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{income.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {income.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {income.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {income.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{income.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{income.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {income.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="income-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {income.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="./screens/admin/NetCash">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderIncomeDetails()
      )}
    </>
  );
};

export default IncomeScreen;